import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export function ModalConfirmDelete({ isOpen, messageTitle, idAccount, action, toggleDialogDelete }) {
    const [open, setOpen] = useState(isOpen);

    const handleClose = (e, r) => {
        if (r === 'backdropClick') {
            return
        }
        setOpen(false);
    };

    const handleClick = (type, action) => {

        switch (type) {
            case 'Eliminar':
                action(idAccount);
                break;
            default:
                toggleDialogDelete();
                break;
        }

        toggleDialogDelete();

    }

    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={open}
                onClose={(e, r) => handleClose(e, r)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle style={{fontWeight:'bolder', fontFamily: 'GT Walsheim Pro'}} id="alert-dialog-title">
                    {"Estás seguro?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color:'grey', fontWeight:'normal', fontFamily: 'GT Walsheim Pro'}} id="alert-dialog-description">
                        Estás seguro que deseas eliminar {messageTitle}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button style={{fontWeight:'bold', fontFamily: 'GT Walsheim Pro'}}   type='button' onClick={() => handleClick('Cancelar', action)}>
                        Cancelar
                    </Button>
                    <Button style={{fontWeight:'bold', fontFamily: 'GT Walsheim Pro'}}  variant="contained" color="error" autoFocus type='button' onClick={() => handleClick('Eliminar', action)}>
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}